import SuccessfullyPages from "../pages/commanPage/wallet/components/PaymentSucessPage";
import Buyer from "../pages/buyerAuction/buyer/Buyer";
import DocumnentsCollection from "../pages/buyerAuction/documents/DocumnentsCollection";
import SubcriptionPages from "../pages/buyerAuction/subscriptions/SubcriptionPages";
import SubscriptionDetails from "../pages/buyerAuction/subscriptions/components/SubscriptionDetails";
import SuccessfullyPage from "../pages/buyerAuction/subscriptions/components/SuccessfullyPage";
import AccountDetails from "../pages/buyerAuction/accounts/AccountDetails";
import UpdateBankDetails from "../pages/buyerAuction/accounts/components/UpdateBankDetails";
import PageNotFound from "../pages/commanPage/errorPage/PageNotFound";
import Bid from "../pages/buyerAuction/bitHistory/BidDetail";
import BidCollection from "../pages/buyerAuction/bitHistory/components/BidCollection";
import AuctionDetails from "../pages/buyerAuction/buyer/AuctionDetail/AuctionDetails";
import DownloadInspectionPdf from "../pages/buyerAuction/buyer/AuctionDetail/Inspection/DownloadInspectionPdf";
import ConfirmLotPayments from "../pages/buyerAuction/buyer/AuctionDetail/children/CofirmLotPayments";
import RequestInspection from "../pages/buyerAuction/buyer/AuctionDetail/Inspection/RequestInspection";
import InspectionList from "../pages/buyerAuction/inspection/InspectionList";
import InspectionResponse from "../pages/buyerAuction/inspection/component/InpectionResponse";
import BuyerLiveAuctionPage from "../pages/buyerAuction/liveroom/pages/BuyerLiveRoom";
import OfferDetails from "../pages/buyerAuction/buyer/AuctionDetail/singleOfferForBuyer/OfferDetails";
import MobileLiveView from "../pages/buyerAuction/liveroom/updateLiveRoom/mobileView/MobileLiveView";
import SingleServiceAuctionDetails from "../pages/buyerAuction/buyer/AuctionDetail/SingleServiceAuctionDetails";
import SingleProductAuctionDetails from "../pages/buyerAuction/buyer/AuctionDetail/SingleProductAuctionDetails";
import ConfirmServiceLotPayment from "../pages/buyerAuction/buyer/AuctionDetail/children/ConfirmServiceLotPayment";
import ConfirmProductLotPayment from "../pages/buyerAuction/buyer/AuctionDetail/children/ConfirmProductLotPayment";


export const buyerRoutes = [
  {
    path: "/",
    element: <Buyer />,
  },
  {
    path: "/forward-auction/auction-details/:id",
    element: <AuctionDetails />,
  },
  {
    path: "/reverse-service-auction/auction-details/:id",
    element: <SingleServiceAuctionDetails />,
  },
  {
    path: "/reverse-product-auction/auction-details/:id",
    element: <SingleProductAuctionDetails />,
  },
  {
    path: "download/inspection-pdf/:id",
    element: <DownloadInspectionPdf />,
  },
  {
    path: "documents/showDetails",
    element: <DocumnentsCollection />,
  },
  {
    path: "subscription",
    element: <SubcriptionPages />,
  },
  {
    path: "subscriptionDetails/:id",
    element: <SubscriptionDetails />,
  },
  {
    path: "confirm-lots-payment/:id/:auctionId",
    element: <ConfirmLotPayments />,
  },
  {
    path: "/service-reverse-auction/confirm-lots-payment/:id/:auctionId",
    element: <ConfirmServiceLotPayment />,
  },
  {
    path: "/product-reverse-auction/confirm-lots-payment/:id/:auctionId",
    element: <ConfirmProductLotPayment />,
  },
  {
    path: "subscription/successful",
    element: <SuccessfullyPage />,
  },
  {
    path: "account",
    element: <AccountDetails />,
  },

  {
    path: "account/update",
    element: <UpdateBankDetails />,
  },
  {
    path: "offer-details/:id/:offerId",
    element: <OfferDetails />,
  },
  {
    path: "request-Inspection/:id",
    element: <RequestInspection />,
  },
  {
    path: "successful-add-money",
    element: <SuccessfullyPages />,
  },
  {
    path: "inspectList",
    element: <InspectionList />,
  },

  {
    path: "inspectList/response/:id",
    element: <InspectionResponse />,
  },

  {
    path: "bid-history",
    element: <Bid />,
  },

  {
    path: "bid/details",
    element: <BidCollection />,
  },
  // {
  //   path: "live-auctions",
  //   element: <BuyerTodayAuctions />,
  // },
  // {
  //   path: "/live-room/:id/:catalogueId",
  //   element: <LiveRoomForLots/>,
  // },
  // {
  //   path: "live-room/:auctionId/:offerId",
  //   element: <BuyerLiveAuctionPage />,
  // },
  {
    path: "live-room-v2/:auctionId/:offerId",
    element: <BuyerLiveAuctionPage />,
  },
  {
    path: "live-room-mobile",
    element: <MobileLiveView />,
  },


  {
    path: "*",
    element: <PageNotFound />,
  },
];
